import React from 'react';
import styles from './GreetingsSettings.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import StyleSelector from '../ConversationSettings/components/style-selector/StyleSelector';
import ColorSelector from '../ConversationSettings/components/color-selector/ColorSelector';
import { useFormikContext } from 'formik';

const GreetingsSettings = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext();

  return (
    <div className={styles['greetings-settings-container']}>
      <Input
        label='Greeting Message'
        value={values?.GreetingMessage}
        maxLength={20}
        inputClassname={styles['input']}
        inputContainerClassName={styles['input-container']}
        name='GreetingMessage'
        onChange={(e) => {
          setFieldValue('GreetingMessage', e.target.value);
        }}
        error={errors?.GreetingMessage}
        touched={touched.GreetingMessage}
        countSpaces
      />
      <StyleSelector
        title='Style'
        value={values?.GreetingStyle}
        onChange={(val) => setFieldValue('GreetingStyle', val)}
        options={[
          { type: 'buttonGradient', value: 'gradient' },
          { type: 'buttonBasic', value: 'basic' },
        ]}
      />
      <ColorSelector
        title='Accent Color'
        colors={['#0957D0', '#128DEA', '#7C3AED', '#0A7E1D', '#FF9706']}
        includePicker
        fieldName='GreetingAccentColor'
        value={values.GreetingAccentColor}
        setFieldValue={setFieldValue}
        onEyeClick={() => {}}
        hasView={false}
      />
    </div>
  );
};

export default GreetingsSettings;
